export const styles = {
  searchField: {
    width: "320px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      transition: "all 0.2s ease",
      fontSize: "14px",
      "& fieldset": {
        borderColor: "#E5E7EB",
      },
      "&:hover fieldset": {
        borderColor: "#9CA3AF",
        boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3B82F6",
        boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
      },
    },
  },
  countBadge: {
    px: 2,
    py: 1,
    borderRadius: "12px",
    backgroundColor: "#F3F4F6",
    border: "1px solid #E5E7EB",
  },
  filterChip: {
    cursor: "pointer",
    height: "32px",
    fontWeight: 600,
    fontSize: "0.85rem",
    borderRadius: "12px",
    backgroundColor: "#fff",
    color: "#6B7280",
    border: "2px solid #E5E7EB",
    "&:hover": {
      backgroundColor: "#F9FAFB",
      borderColor: "#9CA3AF",
    },
  },
  filterChipSelected: {
    backgroundColor: "#3B82F6",
    color: "#fff",
    border: "2px solid #3B82F6",
    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
    "&:hover": {
      backgroundColor: "#2563EB",
      borderColor: "#2563EB",
    },
  },
};
